import { ToggleGroup, ToggleGroupItem, Tooltip } from "@motley/design"
import type { ComponentProps, ReactNode } from "react"
import FormControl from "./FormControl"

type Props = ComponentProps<typeof ToggleGroup> & {
  name: string
  options: {
    label: ReactNode
    value: string
    tooltip?: string
  }[]
}

export default function FormToggleButton({
  name,
  options,
  onValueChange,
  ...rest
}: Props) {
  return (
    <FormControl name={name} required>
      {({ field: { value, onChange, ...restField } }) => {
        const handleChange = (
          ...args: Parameters<NonNullable<typeof onValueChange>>
        ) => {
          const [next] = args[0]
          // A second click un-presses the option; the field is required, so keep it.
          if (!next) {
            return
          }
          onChange(next)
          onValueChange?.(...args)
        }

        return (
          <ToggleGroup
            value={value ? [value] : []}
            onValueChange={handleChange}
            {...restField}
            {...rest}
            multiple={false}
          >
            {options.map(({ label, value, tooltip }) => (
              <Tooltip
                key={value}
                tooltip={tooltip}
                side={rest.orientation === "vertical" ? "right" : "top"}
              >
                <ToggleGroupItem value={value}>{label}</ToggleGroupItem>
              </Tooltip>
            ))}
          </ToggleGroup>
        )
      }}
    </FormControl>
  )
}
